module.exports = __webpack_public_path__ + "static/media/poster.b93f5743.png";